import logoRed from "../assets/images/logored.svg";

const UPDATED_AT = "June 10, 2026";

export default function Terms() {
  return (
    <main className="min-h-screen bg-[#F6F7F9] px-5 py-6 text-[#1A1A1A] sm:px-8">
      <div className="mx-auto max-w-4xl">
        <header className="mb-6 flex items-center">
          <a href="/" className="inline-flex items-center gap-3" aria-label="Strobe Aviation home">
            <img src={logoRed} alt="Strobe Aviation" className="h-8 w-auto" />
          </a>
        </header>

        <article className="rounded-3xl bg-white p-6 shadow-[0_20px_60px_rgba(0,0,0,0.08)] sm:p-10">
          <p className="text-sm text-black/50">Last updated: {UPDATED_AT}</p>
          <h1 className="mt-2 text-3xl font-bold tracking-tight sm:text-4xl">Terms of Service</h1>
          <p className="mt-4 text-black/65">
            These Terms of Service govern access to and use of the Strobe Aviation website, broker portal,
            admin portal, request forms, notifications, and related services.
          </p>

          <section className="mt-8 space-y-4">
            <h2 className="text-xl font-semibold">Use of the Portal</h2>
            <p className="text-black/65">
              The portal is provided for aviation photography request management. Broker users may submit,
              view, and manage requests for their broker account. Admin users may manage Strobe Aviation
              operations, scheduling, status updates, and related request details.
            </p>
            <p className="text-black/65">
              You agree to provide accurate information, keep your login credentials secure, and use the
              portal only for authorized business purposes.
            </p>
          </section>

          <section className="mt-8 space-y-4">
            <h2 className="text-xl font-semibold">Notifications and SMS Terms</h2>
            <p className="text-black/65">
              If you opt in to email or SMS notifications, Strobe Aviation may send transactional messages
              about broker request submissions, request edits, deletes, project scheduling, and project status
              updates. Message frequency varies based on account activity.
            </p>
            <p className="text-black/65">
              Message and data rates may apply. Consent to receive SMS notifications is not required to use
              the portal. You can change notification preferences in your portal settings.
            </p>
            <p className="text-black/65">
              For SMS notifications, reply STOP to unsubscribe. For help, contact support@strobeaviation.com.
              The notification number does not accept replies for support conversations.
            </p>
            <p className="text-black/65">
              SMS opt-in data and consent are not sold, rented, shared, or transferred to third parties
              or affiliates. SMS consent is used only to send the transactional notifications selected by
              the opted-in portal user.
            </p>
          </section>

          <section className="mt-8 space-y-4">
            <h2 className="text-xl font-semibold">Request Information</h2>
            <p className="text-black/65">
              You are responsible for the accuracy of tail numbers, airport identifiers, contact details,
              requested services, notes, and scheduling-related information submitted through the portal.
              Strobe Aviation may contact you to clarify or confirm request details.
            </p>
          </section>

          <section className="mt-8 space-y-4">
            <h2 className="text-xl font-semibold">Account Access</h2>
            <p className="text-black/65">
              Broker account owners may invite team members to help manage requests under the same
              broker account. Admin access is limited to authorized Strobe Aviation team members. You are
              responsible for actions taken through your account.
            </p>
          </section>

          <section className="mt-8 space-y-4">
            <h2 className="text-xl font-semibold">Service Changes</h2>
            <p className="text-black/65">
              Strobe Aviation may update the website, portal, workflows, notification methods, and these terms
              from time to time. Continued use of the portal after updates means you accept the revised terms.
            </p>
          </section>

          <section className="mt-8 space-y-4">
            <h2 className="text-xl font-semibold">Contact</h2>
            <p className="text-black/65">
              Questions about these terms can be sent to support@strobeaviation.com.
            </p>
          </section>
        </article>
      </div>
    </main>
  );
}
